<script>
import isEqual from 'lodash-es/isEqual'

const getData = (entity) => {
    let data
    if (null == entity) data = null
    if ('function' === typeof entity.getData) data = entity.getData()

    // At this point we will have data assigned to either:
    // - The custom data assigned to an object.
    // - A wrapper object in the case of a cluster.
    if (null != data && 'function' === typeof data.getData) data = data.getData()
    if (null != data && 'function' === typeof data.forEachDataPoint) {
        const nextData = []
        data.forEachDataPoint(p => nextData.push(p.getData()))
        data = nextData
    }

    return data
}

export default {
    name: 'HereClusteringLayer',
    inject: ['map', 'ui', 'group'],
    props: {
        data: {
            type: Array,
            required: true
        },
        options: {
            type: Object,
            required: false
        },
        theme: {
            type: Object,
            required: false
        },
        onClick: {
            type: Function,
            required: false
        },
        onClusterBubbleOpen: {
            type: Function,
            required: false
        },
        isMultiEvents: {
            type: Boolean,
            required: false
        }
    },
    data () {
        return {
            layer: null,
            dataProvider: null
        }
    },
    computed: {
    },
    watch: {
        data: {
            handler (newVal, oldVal) {
                if (!isEqual(newVal, oldVal)) {
                    this.removeClusteringLayer()
                    this.addClusteringLayer()
                }
            },
            deep: true
        }
    },
    mounted () {
        this.addClusteringLayer()
    },
    beforeDestroy () {
        this.removeClusteringLayer()
    },
    methods: {
        locationPointsToDataPointsArr (points) {
            return points.map(point => new H.clustering.DataPoint(
                point.lat,
                point.lng,
                null,
                point.data
            ))
        },
        addClusteringLayer () {
            if (null == this.map() || null != this.layer || !this.data || 0 === this.data.length) return
            const providerSettings = {
                clusteringOptions: this.options,
                theme: this.theme
            }

            this.dataProvider = new H.clustering.Provider(
                this.locationPointsToDataPointsArr(this.data),
                providerSettings
            )

            this.layer = new H.map.layer.ObjectLayer(this.dataProvider)

            this.map().addLayer(this.layer, 2)

            this.dataProvider.addEventListener(
                'pointerenter',
                (event) => {
                    const clusterData = event.target.getData()
                    const clusterLocation = clusterData.m && clusterData.m.lat ? clusterData.m : clusterData.s
                    this.onClusterBubbleOpen(getData(event.target), {
                        lat: clusterLocation && clusterLocation.lat,
                        lng: clusterLocation && clusterLocation.lng
                    })
                },
                true
            )
        },
        removeClusteringLayer () {
            if (null == this.map() || null == this.layer) return

            this.map().removeLayer(this.layer)

            this.layer = null
        }
    },
    render () {
        return null
    }
}
</script>
